module.exports = __webpack_public_path__ + "static/floor_preview__2-3f445406192564b14a5695818c40ef4d.png";